import type { PropsWithChildren } from "react";
import type { Props } from "./ConfigurationsGridActionsContext";
import { ConfigurationsGridActionsContext } from "./ConfigurationsGridActionsContext";

export const ConfigurationsGridActionsContextProvider = ({
  configurations,
  onRenameConfiguration,
  onDeleteConfiguration,
  onAssignClient,
  children,
}: PropsWithChildren<Props>) => (
  <ConfigurationsGridActionsContext
    value={{ configurations, onRenameConfiguration, onDeleteConfiguration, onAssignClient }}
  >
    {children}
  </ConfigurationsGridActionsContext>
);
